import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useIntl } from 'react-intl';

import { SortableTourList } from '#components/tourStops/SortableTourList.tsx';
import type { TourStop } from '#domain/TourStop.ts';

type TourDuplicateSortStopsDialogProps = {
    showStopOrderDialog: boolean;
    setShowStopOrderDialog: (show: boolean) => void;
    isMisplaced: boolean;
    misplacedStopIds: string[];
    sortableTourStops: TourStop[];
    setSortableTourStops: (stops: TourStop[]) => void;
};

export const TourDuplicateSortStopsDialog = ({
    showStopOrderDialog,
    setShowStopOrderDialog,
    isMisplaced,
    misplacedStopIds,
    sortableTourStops,
    setSortableTourStops,
}: TourDuplicateSortStopsDialogProps) => {
    const intl = useIntl();
    const dialogTitleId = 'intl-msg:ordercom-cloud-frontend.tours.duplicate.stop-order-dialog.title';

    return (
        <Dialog
            show={showStopOrderDialog}
            title={intl.formatMessage({
                id: dialogTitleId,
            })}
            body={
                <div className='padding-top-5'>
                    <SortableTourList
                        sortableTourStops={sortableTourStops}
                        setSortableTourStops={setSortableTourStops}
                        misplacedStopIds={misplacedStopIds}
                    />
                </div>
            }
            footer={
                <ButtonToolbar alignment='right' className='width-100pct'>
                    <Button
                        bsStyle='primary'
                        autoTrackingKey='ordercom.tours.duplicate.stop-order-dialog.apply'
                        onClick={() => setShowStopOrderDialog(false)}
                        disabled={isMisplaced}
                    >
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.common.apply',
                        })}
                    </Button>
                </ButtonToolbar>
            }
            onClose={() => setShowStopOrderDialog(false)}
            bsSize='md'
            showCloseButton={false}
            headerButtons={
                <Button
                    bsStyle={Button.MUTED}
                    iconOnly
                    iconName='remove'
                    autoTrackingKey={`${dialogTitleId}.close`}
                    className='modal-header-close close'
                    onClick={() => setShowStopOrderDialog(false)}
                    aria-label='dialog close button'
                />
            }
            data-testid='tour-duplicate-stop-order-dialog'
        />
    );
};
